export function colorShiftText() {
    document.addEventListener("DOMContentLoaded", () => {
        const blocks = document.querySelectorAll(".color-shift-text");

        function splitNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const frag = document.createDocumentFragment();
                for (let char of node.textContent) {
                    if (char === " ") {
                        frag.appendChild(document.createTextNode(" "));
                    } else {
                        const span = document.createElement("span");
                        span.textContent = char;
                        frag.appendChild(span);
                    }
                }
                return frag;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const clone = node.cloneNode(false);
                node.childNodes.forEach(child => {
                    clone.appendChild(splitNode(child));
                });
                return clone;
            }
            return document.createTextNode("");
        }

        blocks.forEach(block => {
            const newContent = document.createDocumentFragment();
            block.childNodes.forEach(child => {
                newContent.appendChild(splitNode(child));
            });
            block.innerHTML = "";
            block.appendChild(newContent);
        });

        function animateOnScroll() {
            blocks.forEach(block => {
                const spans = block.querySelectorAll("span");
                const total = spans.length;
                const rect = block.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const visible = Math.min(
                    1,
                    Math.max(0, (windowHeight - rect.top) / (rect.height + windowHeight))
                );

                const charsToShow = Math.floor(total * visible * 1.5);

                spans.forEach((span, i) => {
                    if (i < charsToShow) {
                        span.classList.add("filled");
                    } else {
                        span.classList.remove("filled");
                    }
                });
            });
        }

        window.addEventListener("scroll", animateOnScroll);
        window.addEventListener("resize", animateOnScroll);
        animateOnScroll();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/colorShiftText.js